




















import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'

@Component
export default class UpdateMaxActivitiesLimitPopup extends Vue {
    @Prop() popupId!: string
    @Prop() brandId!: string
    public payload = {
      maxActivitiesLimit: ''
    }
    updateLimit () {
      this.$validator.validateAll('update-max-activities-form').then((result) => {
        if (result) {
          const popupCloseButton: HTMLElement = this.$refs.popupCloseButton as HTMLElement
          this.$store.dispatch('updateBrandMaxActivitiesLimit', { id: this.brandId, data: this.payload }).then(() => {
            this.$notify({ text: `${this.payload.maxActivitiesLimit} set as max activities limit for brand`, type: 'success' })
            Object.assign(this.$data, (this.$options.data as any).apply(this))
            this.$nextTick()
              .then(() => {
                this.$validator.errors.clear('update-max-activities-form')
              })
            this.$emit('updated')
            popupCloseButton.click()
          }, () => this.$notify({ text: 'Error while updating max activities limit', type: 'error' }))
        } else if (this.$validator.errors.has('update-max-activities-form.max-activities-limit')) {
          this.$notify({ text: this.$validator.errors.first('update-max-activities-form.max-activities-limit'), type: 'error' })
        }
      })
    }
}
